import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'BaseBanner',
  props: {
  color: {
    type: String,
    default: 'primary',
    validator: (value: string) => ['primary', 'secondary', 'success', 'alert', 'danger', 'gray'].includes(value)
  },

  size: {
    type: String,
    default: 'medium',
    validator: (value: string) => ['xsmall', 'small', 'medium', 'large'].includes(value)
  },

  label: {
    type: String,
    default: null
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_MkBadge = _resolveComponent("MkBadge")!

  return (_openBlock(), _createBlock(_component_MkBadge, {
    rounded: false,
    color: __props.color,
    block: "",
    size: __props.size,
    filled: "",
    label: __props.label
  }, null, 8, ["color", "size", "label"]))
}
}

})